import React from "react";

import styled from "styled-components";

import UserDropDown from "./UserDropDown";
import SiteSelector from "./SiteSelector";
import Promotion from "./Promotion";


const HeaderWrapper = styled.section`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const RightContainer = styled.section`
  display: grid;
  align-items: center;
  grid-template-columns: repeat(2, 1fr);
`;



const Navbar: React.FC = () => (
  <HeaderWrapper>
    <SiteSelector />
    <RightContainer>
      <Promotion />
      <UserDropDown />
    </RightContainer>
  </HeaderWrapper>
);

export default Navbar;
